<template>
    <v-container fluid :class="'mb-1 bg-' + timerBgVariant + ' border-light border-sm border-opacity-100'">
        <v-row align="center">
            <v-col cols="auto">
                <v-btn color="error" icon="mdi-trash-can-outline" @click="remove"/>
            </v-col>
            <v-col>
                <v-text-field :disabled="running" v-model="timerData.text" density="compact" hide-details @update:modelValue="textChanged"/>
            </v-col>
            <v-col v-if="!running" cols="auto">
                <v-btn color="secondary" icon="mdi-arrow-down" :disabled="running" class="ml-1" @click="dec"/>
                <v-btn color="secondary" icon="mdi-arrow-up" :disabled="running" class="ml-1" @click="inc"/>
            </v-col>                
            <v-col cols="auto" style="font-size: 2rem;" :class="'text-light text-center font-weight-bold'">
                <span :class="running ? 'text-white' : ''">{{ timerDisplay }}</span>
                <audio ref="alert" style="display: none" id="kcTimerAlert" volume="1" :src="completeSound"/>
            </v-col>
            <v-col v-if="!running && !finished" cols="auto">
                <v-btn color="secondary" icon="mdi-play" @click="run"/>
            </v-col>
            <v-col v-if="running || finished" cols="auto">
                <v-btn color="secondary" @click="reset" class="ml-1"><v-icon icon="mdi-stop"/></v-btn>
            </v-col>            
        </v-row>
    </v-container>
</template>
<script>
import completeSound from '../assets/complete.mp3';
export default {
    name: 'kc-timer',
    emits: [ 'update:modelValue', 'remove' ],
    components: {
    },  
    data() {
        return {    
            running: false,
            finished: false,
            timerBgVariant: 'surface-lighten-1',
            timerInterval: null,
            alertInterval: null,
            completeSound
        }
    },
    props: {
        modelValue: {
            type: Object,
            required: true
        }
    },
    computed: {
        timerData: {
            get() {
                const vm = this;
                return vm.modelValue;
            },
            set(v) {
                const vm = this;
                vm.$emit('update:modelValue', v);
            }
        },
        timerDisplay() {
            const vm = this;
            var minutes = Math.floor(vm.timerData.timer / 60);
            var seconds = Math.abs(vm.timerData.timer - (minutes * 60));
            return vm.pad(minutes, 2) + ':' + vm.pad(seconds, 2);
        },
    },
    methods: {
        remove() {
            const vm = this;
            vm.reset();
            vm.$emit('remove');
        },
        textChanged() {
            const vm = this;
            vm.$emit('update:modelValue', vm.modelValue);
        },
        inc() {
            const vm = this;
            vm.timerData.startTime += 60;
            if (vm.timerData.startTime > 21600) vm.timerData.startTime = 21600;
            vm.timerData.timer = vm.timerData.startTime;
            vm.$emit('update:modelValue', vm.modelValue);
        },
        dec() {
            const vm = this;
            vm.timerData.startTime  -= 60;
            if (vm.timerData.startTime  < 60) vm.timerData.startTime  = 60;
            vm.timerData.timer = vm.timerData.startTime;
            vm.$emit('update:modelValue', vm.modelValue);
        },
        run() {
            const vm = this;
            var start = vm.$dayjs();
            vm.running = true;     
            vm.finished = false;
            vm.timerBgVariant = 'success';
            vm.timerData.timer = vm.timerData.startTime;
            vm.timerInterval = setInterval(() => {
                var now = vm.$dayjs();
                var duration = vm.$dayjs.duration(now.diff(start));
                vm.timerData.timer = Math.round(vm.timerData.startTime  - duration.asSeconds());
                if (vm.timerData.timer <= 0) {
                    clearInterval(vm.timerInterval);
                    vm.finished = true;
                    vm.running = false;
                    vm.alertSound();
                    var counter = 1;
                    vm.timerBgVariant = 'danger';
                    vm.alertInterval = setInterval(() => {
                        if (vm.timerBgVariant === 'success') {
                            vm.timerBgVariant = 'danger';
                        } else {
                            vm.timerBgVariant = 'success';
                        }
                        counter++;
                        if (counter === 10) {
                            vm.alertSound();
                            counter = 1;
                        }
                    }, 250);                  
                }
            }, 10);
        },
        reset() {
            const vm = this;
            if (vm.timerInterval !== null) {
                clearInterval(vm.timerInterval);
            }
            if (vm.alertInterval !== null) {
                clearInterval(vm.alertInterval);
            }          
            vm.running = false;
            vm.finished = false;
            vm.timerBgVariant = 'dark';
            vm.timerInterval = null;
            vm.alertInterval = null;
            vm.timerData.timer = vm.timerData.startTime;
        },
        pad(num, size) {
            num = num.toString();
            while (num.length < size) num = "0" + num;
            return num;
        },
        alertSound() {
            const vm = this;
            vm.$refs.alert.play();
        }
    }
}
</script>
<style lang="sass" scoped>
</style>